import { App } from 'vue'
// 导入基础组件
import { ElIcon, ElDialog, ElPopover, ElTooltip, ElButton, ElForm, ElFormItem, ElInput, ElUpload } from 'element-plus'
import 'dayjs/locale/zh-cn'

const ElComponents = [ElIcon, ElDialog, ElPopover, ElTooltip, ElButton, ElForm, ElFormItem, ElInput, ElUpload]
// const plugins = [ElMessageBox]

const install = (app: App) => {
  // elementUI
  ElComponents.forEach((el) => {
    app.component(el.name, el)
  })
  // plugins.forEach((plugin: any) => {
  //   app.use(plugin)
  // })
}

export default install
